export const FETCH_REMINDERS_START = "ISOLATED_REMINDERS/FETCH_REMINDERS_START";
export const FETCH_REMINDERS_SUCCESS = "ISOLATED_REMINDERS/FETCH_REMINDERS_SUCCESS";
export const ADD_REMINDER_START = "ISOLATED_REMINDERS/ADD_REMINDER_START";
export const ADD_REMINDER_SUCCESS = "ISOLATED_REMINDERS/ADD_REMINDER_SUCCESS";
export const EDIT_REMINDER_START = "ISOLATED_REMINDERS/EDIT_REMINDER_START";
export const EDIT_REMINDER_SUCCESS = "ISOLATED_REMINDERS/EDIT_REMINDER_SUCCESS";
export const DELETE_REMINDER_START = "ISOLATED_REMINDERS/DELETE_REMINDER_START";
export const DELETE_REMINDER_SUCCESS = "ISOLATED_REMINDERS/DELETE_REMINDER_SUCCESS";
export const REMINDERS_API_ERROR = "ISOLATED_REMINDERS/REMINDERS_API_ERROR";
export const CLEAR_REMINDERS_MODAL = "ISOLATED_REMINDERS/CLEAR_REMINDERS_MODAL";
